import React, { useState, useEffect } from 'react';
import { IRotatingBannerContent } from '@dazn/lp-web/src/types';

import styles from '@dazn/lp-web/src/components/BannerSlider/MobileSlider/mobile-slider.module.css';
import classNames from 'classnames';

// Utility function to replace \n with <br /> elements
const formatStringWithLineBreaks = (str: string) => {
    return str.split(/\\n|\n/).map((part, index) => (
        <React.Fragment key={index}>
            {part}
            {index < str.split(/\\n|\n/).length - 1 && <br />}
        </React.Fragment>
    ));
};


export const MobileRotatingBannerContent: React.FC<{
    rotatingContentItem: IRotatingBannerContent[];
}> = ({rotatingContentItem}) => {
    const [currentIndex, setCurrentIndex] = useState(0);

    useEffect(() => {
        if (!rotatingContentItem || rotatingContentItem.length === 0) return;

        const interval = setInterval(() => {
            setCurrentIndex((prevIndex: number) =>
                (prevIndex + 1) % rotatingContentItem.length
            );
        }, 3000); // Rotate every 1.3 seconds

        return () => clearInterval(interval);
    }, [rotatingContentItem]);

    if (!rotatingContentItem || rotatingContentItem.length === 0) {
        return null;
    }

    return (
        <div className={styles.rotatingBannerContainer}>
            {rotatingContentItem.map((content, index) => (
                <div
                    key={index}
                    className={classNames(styles.rotatingBanner, {
                        [styles.rotatingBannerSwap]: index === currentIndex,
                        [styles.hidden]: index !== currentIndex,
                        [styles.nextRotatingBanner]: index === currentIndex + 1
                    })}
                >


                    <div
                        className={classNames(
                            styles.mobileRotatingBannerContent,
                            {
                                [styles.mobileRotatingBannerContentSection]:
                                    true
                        })}
                    >
                        <h2 className={styles.rotatingBannerValue}>
                            {formatStringWithLineBreaks(
                                `${content.key} ${content.value}`
                            )}
                        </h2>
                    </div>

                </div>
            ))}
        </div>
    );
};